// Figma: "Footer" (e.g. node 18050:189) — Terms / Privacy policy, centered. The design's
// "Support" link is intentionally omitted.
import React from 'react';
import {Link, Stack, Typography} from '@mui/material';
import {tokens} from '../../../themes/ThemeCustomization';

const AuthFooter = () => (
    <Stack direction="row" spacing={2} justifyContent="center" sx={{py: 3, color: tokens.color.neutral500}}>
        <Typography
            component={Link}
            href="https://www.stake.rent/terms"
            variant="caption"
            fontWeight={500}
            color="inherit"
            underline="hover"
        >
            Terms
        </Typography>
        <Typography
            component={Link}
            href="https://www.stake.rent/privacy"
            variant="caption"
            fontWeight={500}
            color="inherit"
            underline="hover"
        >
            Privacy policy
        </Typography>
    </Stack>
);

export default AuthFooter;
